import Algolia from './search/algolia';

window.StaticSnapFrontend.Search.addModule(new Algolia(window.StaticSnapFrontend));
